export const theme = {
  colors: {
    brand: '#0056b3',
    brandDark: '#003366',
    brandTint: '#e8f1ff',
    text: '#1f2a44',
    muted: '#5f6f86',
    bg: '#ffffff',
    bgSubtle: '#f7faff',
    cardBg: '#ffffff',
    border: '#d6e4ff',
    accent: '#00a8ff',
    success: '#2ca58d',
    successBg: '#e6f6f2',
    danger: '#dc3545',
    dangerBg: '#fdecee'
  },
  space: { xs: 4, sm: 8, md: 16, lg: 24, xl: 32, xxl: 48 },
  radii: { sm: 8, md: 12, lg: 18, pill: 999 },
  breakpoints: {
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px'
  },
  shadow: {
    sm: '0 1px 2px rgba(13, 27, 42, 0.04), 0 6px 16px rgba(13, 27, 42, 0.06)',
    md: '0 2px 4px rgba(13, 27, 42, 0.05), 0 14px 28px rgba(13, 27, 42, 0.1)',
    lg: '0 4px 8px rgba(13, 27, 42, 0.06), 0 24px 48px rgba(13, 27, 42, 0.14)'
  },
  focusRing: '0 0 0 3px rgba(0, 86, 179, 0.28)',
  transition: {
    fast: '0.15s ease',
    base: '0.2s ease',
    slow: '0.3s ease'
  },
  container: '1240px'
};
